const VoucherIssuanceType = {
    PRICE: 1,
    PERCENT: 2
}
export default VoucherIssuanceType